import { DownloadButtons } from "components/CountryDetails/DownloadButtons";
import Rankings from "./Rankings";

const Output = () => {
    return (
        <>
            <DownloadButtons />
            <Rankings />
        </>
    );
}

export default Output;
